import common from '../common.js';

export default {
    // Resolves an IANA timezone id (e.g. "America/Edmonton") from GPS
    // coordinates via our backend's /timezone endpoint, which proxies the
    // lookup to Mapbox server-side. Expected response shape:
    //   { "timezone": "America/Edmonton" }  (or null/missing if unresolved)
    async lookupTimezone(context, { latitude, longitude } = {}) {
        const lat = parseFloat(latitude);
        const lon = parseFloat(longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
            context.commit('SET_DETECTED_TIMEZONE', null);
            return null;
        }

        let tzId = null;
        try {
            const data = await common.getRequest(context, null, `timezone?latitude=${lat}&longitude=${lon}`);
            tzId = data?.timezone || null;
        } catch (e) {
            tzId = null;
        }

        context.commit('SET_DETECTED_TIMEZONE', tzId);
        return tzId;
    },
};
